export const getAllWarehouses = (state) => state.warehouses;

export const findWarehouseById = (state, id) => state?.[id] || null;

export const getWarehouseById = (id) => (state) =>
  findWarehouseById(state.warehouses, id);
